// utils/scrollCache.js
// 全局滚动位置缓存对象
export const scrollPosCache = {}

// 监听页面刷新/关闭事件，清空缓存
window.addEventListener('beforeunload', () => {
  // 清空缓存对象的所有属性
  Object.assign(scrollPosCache, {})
})
